import { render, staticRenderFns } from "./SoliTeachers.vue?vue&type=template&id=6dc2d4bc"
import script from "./SoliTeachers.vue?vue&type=script&lang=js"
export * from "./SoliTeachers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports